import type { UserRole } from './user-role.enum';
import type { JwtDeviceDto, JwtExternalDriverDto } from '@carvia/ros-client-types';

export interface JWTUser {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: UserRole;
  isEmailConfirmed: boolean;
}

export type TokenPayload = JWTUser | JwtDeviceDto | JwtExternalDriverDto;

export function isJWTUser(payload: unknown): payload is JWTUser {
  return !!payload && typeof payload === 'object' && 'role' in payload;
}

export function isDeviceTokenPayload(payload: unknown): payload is JwtDeviceDto {
  return !!payload && typeof payload === 'object' && 'deviceRole' in payload;
}

export function isExternalDriverTokenPayload(payload: unknown): payload is JwtExternalDriverDto {
  return (
    !!payload &&
    typeof payload === 'object' &&
    'externalDriverAccess' in payload &&
    payload.externalDriverAccess === true
  );
}
